<p>
  {{message}}
</p>
<button class="mat-raised-button mat-warn" (click)="logout()">
  Logout
</button>
